/**
 * Copyright (c) 2020, 2023 Visa, Inc.
 *
 * This source code is licensed under the MIT license
 * https://github.com/visa/visa-chart-components/blob/master/LICENSE
 *
 **/
export class DataTableDefaultValues {
  static readonly language = 'en';
  static readonly isCompact = false;
  static readonly hideDataTable = false;
  static readonly padding = {
    top: 20,
    bottom: 50,
    right: 60,
    left: 60
  };
  static readonly margin = {
    top: 325 * 0.01,
    bottom: 325 * 0.01,
    right: 675 * 0.01,
    left: 675 * 0.01
  };
}
